import { useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import { findTranslation } from '../../../../utils/helpers';
import { getSmokeBehaviourOptions } from '../../profile/HealthSection';
import {useTranslation} from "react-i18next";

const SECTION = 'partner_health';

const ComparePartnerHealthSection = () => {
  const {
    showOnlyDiff,
    hasDiff,
    shouldShow,
    ownPartnerData,
    otherPartnerData,
    handlePartnerDataChange,
    healthFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleDataChange = (e) => {
    handlePartnerDataChange(e, SECTION);
  };

  if (
    showOnlyDiff &&
    !hasSectionCopiedFields(SECTION) &&
    !hasDiff(healthFields, ownPartnerData, otherPartnerData)
  )
    return null;

  return (
    <Stack space="l">
      <CategoryHeader>
        <span>{t('Gezondheid partner')}</span>
        <span>{t('Gezondheid partner')}</span>
      </CategoryHeader>
      <Stack space="m">
        {shouldShow('is_smoker', ownPartnerData, otherPartnerData, SECTION) && (
          <Compare
            label={t("Rookgedrag?")}
            name="is_smoker"
            section={SECTION}
            leftValue={ownPartnerData?.is_smoker}
            rightValue={otherPartnerData?.is_smoker}
            valueTransformer={(value) =>
              findTranslation(value, getSmokeBehaviourOptions())
            }
            onUpdate={handleDataChange}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default ComparePartnerHealthSection;
